import { useEffect, useRef } from "react";

export const useScrollTop = (data) => {
  const ref = useRef();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (ref.current) {
        ref.current.scrollTop = 0;
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [data]);

  return ref;
};
